import { render, staticRenderFns } from "./company_auth_table.vue?vue&type=template&id=32286249&scoped=true"
import script from "./company_auth_table.vue?vue&type=script&lang=ts"
export * from "./company_auth_table.vue?vue&type=script&lang=ts"
import style0 from "./company_auth_table.vue?vue&type=style&index=0&id=32286249&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32286249",
  null
  
)

export default component.exports